import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';

export interface IOfferMapInfrastructureCheckboxProps {
  active?: boolean;
}

export class OfferMapInfrastructureCheckbox extends React.Component<IOfferMapInfrastructureCheckboxProps> {
  public render() {
    const { active } = this.props;

    return (
      <span {...mergeStyles(styles['checkbox'], active && styles['checkbox--active'])}>
        {active && (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.222 7.463" width="9" height="7">
            <path
              fill="#FFF"
              d="M3.062 6.86l.745.603.633-.72 4.782-5.42L7.722 0 3.507 4.78 1.26 2.83 0 4.387 3.062 6.86z"
            />
          </svg>
        )}
      </span>
    );
  }
}
